import { extractKnownSlices, extractSeoData } from '~utils/unfurl-helpers';

export default prismicData => ({
  seo: extractSeoData(prismicData, 'prismicTerms'),
  slices: extractKnownSlices(prismicData, 'prismicTerms.data.body')
});
